import {BaseIntDTO} from "../_baseIntDTO.interface";
import {FaultCategoryDTO} from "./fault-category.dto.interface";

export interface FaultCheckTypeCategoryDTO extends BaseIntDTO {
  faultCheckTypeId?: number;
  faultCategoryId?: number;
  faultCategory?: FaultCategoryDTO;
  sequence?: number;
}
